module.exports = __webpack_public_path__ + "46775c20.svg";